// src/scripts/contact-form.ts
import { submitContact } from '../lib/api';

function qs<T extends HTMLElement>(sel: string) {
  return (typeof document !== 'undefined' ? document.querySelector(sel) : null) as T | null;
}

// --- Toast Tailwind (verde/rojo) ---
function showToast(message: string, type: 'success' | 'error' = 'success') {
  const toast = qs<HTMLDivElement>('#toast');
  const text = qs<HTMLSpanElement>('#toast-text');
  if (!toast || !text) return;

  text.textContent = message;
  toast.classList.remove('hidden', 'opacity-0', 'translate-y-2', 'bg-green-600', 'bg-red-600');
  toast.classList.add(type === 'success' ? 'bg-green-600' : 'bg-red-600');

  requestAnimationFrame(() => {
    void toast.offsetWidth;
    toast.classList.add('transition-all', 'duration-300');
    toast.classList.remove('opacity-0', 'translate-y-2');
  });

  window.setTimeout(() => {
    toast.classList.add('opacity-0', 'translate-y-2');
    window.setTimeout(() => toast.classList.add('hidden'), 300);
  }, 2500);
}

const REASONS_MAP: Record<string, number> = {
  recruiter: 1,
  pyme: 2,
  freelance: 3,
  other: 4,
};

function setupContactForm() {
  const form = qs<HTMLFormElement>('form');
  if (!form) return;

  form.addEventListener('submit', async (e) => {
    e.preventDefault();

    if (!form.reportValidity()) return;

    const fd = new FormData(form);
    const reasonKey = String(fd.get('reason') || '').trim().toLowerCase();
    const name = String(fd.get('name') || '').trim();
    const email = String(fd.get('email') || '').trim();
    const phone = String(fd.get('phone') || '').trim();
    const company = String(fd.get('company') || '').trim();
    const message = String(fd.get('message') || '').trim();

    const reason = REASONS_MAP[reasonKey] ?? (Number.isFinite(Number(reasonKey)) ? Number(reasonKey) : NaN);
    if (!Number.isFinite(reason)) {
      showToast('Selecciona un motivo válido.', 'error');
      return;
    }

    if (phone && phone.replace(/\D/g, '').length < 6) {
      showToast('Teléfono inválido (opcional).', 'error');
      return;
    }

    const submitBtn = form.querySelector<HTMLButtonElement>('button[type="submit"]');
    const original = submitBtn?.textContent;
    submitBtn?.setAttribute('disabled', 'true');
    if (submitBtn) submitBtn.textContent = 'Enviando…';

    const payload = {
      name,
      email,
      phone: phone || undefined,
      company: company || undefined,
      reason,
      message,
    };

    try {
      await submitContact(payload); // ← usa BASE correcta
      showToast('¡Gracias! He recibido tu mensaje.', 'success');
      form.reset();
      const select = qs<HTMLSelectElement>('#reason');
      if (select) select.value = '';
    } catch (err) {
      console.error(err);
      showToast('No se pudo enviar. Intenta de nuevo.', 'error');
    } finally {
      submitBtn?.removeAttribute('disabled');
      if (submitBtn && original != null) submitBtn.textContent = original;
    }
  });
}

if (typeof window !== 'undefined' && typeof document !== 'undefined') {
  window.addEventListener('DOMContentLoaded', setupContactForm);
}
